import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./Home";
import Aboutus from "./pages/Aboutus";
import Contactus from "./pages/Contactus";
import Privacypolicy from "./pages/Privacypolicy";
import Terms from "./pages/Terms";
import FullPost from "./pages/FullPost";
import LanguageProvider from "./LanguageContext";
import Collection from "./pages/Collection";
import { PostProvider } from "./context/PostContext";
import ProtectPage from "./pages/ProtectPage";
import RemoveLangParam from "./RemoveLangParam"; // Import the component
import ThemeToggle from "./components/ThemeToggle";
function App() {
  return (
    <PostProvider>
      <LanguageProvider>
        <Router>
          <RemoveLangParam /> {/* This will remove ?lang=english from the URL */}
          <div>
            <ProtectPage />
            <ThemeToggle /> 
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/collection" element={<Collection />} />
              <Route path="/collection/:title/:id" element={<FullPost />} />
              <Route path="/about" element={<Aboutus />} />
              <Route path="/contact" element={<Contactus />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy-policy" element={<Privacypolicy />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </PostProvider>
  );
}

export default App;
